import { render, staticRenderFns } from "./issue-codes.vue?vue&type=template&id=0d027cc7&"
import script from "./issue-codes.vue?vue&type=script&lang=js&"
export * from "./issue-codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports